import { useRequest } from 'src/lib/hooks'
import { CommunityEndpoints } from 'src/modules/community/constants'
import CommunityService from 'src/modules/community/service'

const COMMUNITIES_ROWS = 25

const useGetGroups = ({ membershipSlug }) => {
  const {
    data: groupCommunitiesList,
    isLoading: isLoadingGetGroupCommunities,
    invalidate: invalidateGroupCommunitiesQuery
  } = useRequest([CommunityEndpoints.getGroupCommunities(membershipSlug)], () => {
    return CommunityService.getGroups(membershipSlug, COMMUNITIES_ROWS)
  })

  return {
    groupCommunitiesList,
    isLoadingGetGroupCommunities,
    invalidateGroupCommunitiesQuery
  }
}

export default useGetGroups
